export function resolveMediaUrl(url?: string | null): string {
  if (!url) return '';

  // Already absolute: normalize legacy /uploads to protected media endpoints
  if (/^https?:\/\//i.test(url)) {
    try {
      const u = new URL(url);
      if (u.pathname.startsWith('/uploads/gallery/')) {
        const filename = u.pathname.split('/uploads/gallery/')[1];
        u.pathname = `/api/v1/media/gallery/${filename}`;
        return `${u.origin}${u.pathname}`;
      }
      if (u.pathname.startsWith('/uploads/avatars/')) {
        const filename = u.pathname.split('/uploads/avatars/')[1];
        u.pathname = `/api/v1/media/avatars/${filename}`;
        return `${u.origin}${u.pathname}`;
      }
    } catch (_) {
      // ignore
    }
    return url;
  }

  const envUrl = (import.meta as any)?.env?.VITE_API_URL as string | undefined;
  const backendOrigin = envUrl ? envUrl.replace(/\/?api\/v1\/?$/, '') : `${window.location.protocol}//${window.location.host}`;
  const frontendOrigin = `${window.location.protocol}//${window.location.host}`;

  let path = url.startsWith('/') ? url : `/${url}`;
  if (path.startsWith('/uploads/gallery/')) {
    const filename = path.split('/uploads/gallery/')[1];
    path = `/api/v1/media/gallery/${filename}`;
  } else if (path.startsWith('/uploads/avatars/')) {
    const filename = path.split('/uploads/avatars/')[1];
    path = `/api/v1/media/avatars/${filename}`;
  }

  // Entscheide Ursprung:
  // - Für geschützte/proxied Pfade (/api/..., /uploads/...) → Backend-Origin
  // - Für sonstige relative Assets (z.B. /video_*.mp4 in /public) → Frontend-Origin
  const useBackend = path.startsWith('/api/') || path.startsWith('/uploads/');
  const origin = useBackend ? backendOrigin : frontendOrigin;
  return origin + path;
}

// Lightweight media-type detection based on file extension in URL.
// Non-breaking addition; callers can still pass explicit types if needed.
export function isVideoUrl(url?: string | null): boolean {
  if (!url) return false;
  try {
    const lower = url.toString().toLowerCase();
    return (
      lower.endsWith('.mp4') ||
      lower.endsWith('.webm') ||
      lower.endsWith('.ogg') ||
      lower.endsWith('.ogv') ||
      lower.endsWith('.mov') ||
      lower.includes('/video/') // heuristic for API paths
    );
  } catch (_) {
    return false;
  }
}


